export function normalizeSourceMode(value) {
  return String(value || "").trim().toLowerCase();
}

export function isCustomDeploymentRecord(row) {
  return normalizeSourceMode(row?.sourceMode) === "custom";
}

function normalizeUpper(value) {
  return String(value || "").trim().toUpperCase();
}

function getCustomMetadata(row) {
  const value = row?.customMetadata || row?.deployment?.customMetadata;

  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value;
  }

  return {};
}

export function getDeploymentDisplayName(row) {
  return (
    row?.token?.tokenName ||
    row?.tokenName ||
    row?.contractName ||
    row?.name ||
    "-"
  );
}

export function getDeploymentAddress(row) {
  return row?.address || row?.contractAddress || "";
}

export function getDeploymentTxHash(row) {
  return row?.txHash || "";
}

export function getDeploymentDownload(row) {
  return row?.download || "";
}

export function getDeploymentTokenType(row) {
  const meta = getCustomMetadata(row);

  return normalizeUpper(
    row?.token?.tokenType ||
      row?.tokenType ||
      row?.deployment?.tokenType ||
      meta.tokenType ||
      "",
  );
}

export function getDeploymentStarterTemplate(row) {
  const meta = getCustomMetadata(row);

  return normalizeUpper(
    row?.starterTemplate ||
      row?.deployment?.starterTemplate ||
      meta.starterTemplate ||
      "",
  );
}

export function getDeploymentDetectedContractType(row) {
  const meta = getCustomMetadata(row);

  return (
    row?.detectedContractType ||
    row?.deployment?.detectedContractType ||
    meta.detectedContractType ||
    ""
  );
}

export function getDeploymentDisplayType(row) {
  const meta = getCustomMetadata(row);

  const explicit =
    row?.displayType ||
    row?.deployment?.displayType ||
    meta.displayType ||
    "";

  if (explicit) return explicit;

  const tokenType = getDeploymentTokenType(row);

  if (isCustomDeploymentRecord(row)) {
    if (tokenType === "ERC20") return "Custom ERC20";
    if (tokenType === "ERC721") return "Custom ERC721";
    if (tokenType === "ERC1155") return "Custom ERC1155";
    return "Custom Contract";
  }

  return tokenType || "Contract";
}

export function isDeploymentToken(row) {
  const meta = getCustomMetadata(row);

  if (typeof row?.isToken === "boolean") return row.isToken;
  if (typeof row?.deployment?.isToken === "boolean") return row.deployment.isToken;
  if (typeof meta?.isToken === "boolean") return meta.isToken;

  const tokenType = getDeploymentTokenType(row);

  return tokenType === "ERC20" || tokenType === "ERC721" || tokenType === "ERC1155";
}

export function getDeploymentBundleLabel(row) {
  if (getDeploymentDownload(row)) return "download";
  if (isCustomDeploymentRecord(row)) return "Custom source managed";
  return "No bundle";
}

export function hasDeploymentVerificationContext(row) {
  const network = row?.network;
  const address = getDeploymentAddress(row);
  const requestId = row?.requestId;
  const txHash = row?.txHash;
  const deploymentFile = row?.deploymentFile;
  const artifactKey = row?.artifactKey;

  if (isCustomDeploymentRecord(row)) {
    return Boolean(network && address && (requestId || txHash || deploymentFile || row?.customVersionId));
  }

  return Boolean(network && address && (artifactKey || requestId || txHash || deploymentFile));
}

export function getVerificationSyncPayload(row) {
  return {
    txHash: row?.txHash || null,
    requestId: row?.requestId || null,
    deploymentFile: row?.deploymentFile || null,
    sourceMode: row?.sourceMode || null,
    customVersionId: row?.customVersionId || null,
    contractAddress: getDeploymentAddress(row) || null,
    network: row?.network || null,
    allowFailedRetry: true,
  };
}

export function getCustomVerificationTarget(row) {
  return {
    deploymentFile: row?.deploymentFile || "",
    requestId: row?.requestId || "",
    txHash: row?.txHash || "",
  };
}